import React from 'react';

/**
 * Reusable elected official card.
 */
const ElectedCard = ({ name, role, territory, avatarColor = '#57110f', avatar }) => {
  return (
    <div className="card elected-card">
      <div className="elected-card__avatar">
        <div
          style={{
            width: '100%',
            height: '100%',
            background: avatar ? `url(${avatar}) center/cover no-repeat` : avatarColor,
            borderRadius: 'var(--radius-full)',
          }}
        ></div>
      </div>
      <div className="elected-card__info">
        <div className="elected-card__name">{name}</div>
        <div className="elected-card__role">{role}</div>
        <div className="elected-card__territory">{territory}</div>
      </div>
    </div>
  );
};

export default ElectedCard;
